/* eslint-disable */
// AUTO-GENERATED by scripts/generateOperationRoles.ts — do not edit.
//
// Derived from x-roles and x-required-roles in the OpenAPI spec. Keys are spec
// operationIds, which are also the function names in the generated sdk.gen.ts, so
// every operation the client exposes is listed here.
//
// A user may invoke an operation if they hold ANY of its required roles. An empty
// list mirrors the spec's "any role may invoke this".

export type RequiredRole = 'galvanick:admin' | 'galvanick:read-only' | 'galvanick:user'

/** Every role the API defines, per the spec's x-roles. */
export const ALL_ROLES = ['galvanick:admin', 'galvanick:read-only', 'galvanick:user'] as const satisfies ReadonlyArray<RequiredRole>

export const OPERATION_ROLES = {
  aafhDelete: ['galvanick:admin', 'galvanick:user'],
  aafhGet: [],
  aafhPost: ['galvanick:admin', 'galvanick:user'],
  adsGet: [],
  adsIdGet: [],
  assetsAssetIdCustomAttributesDefinitionIdPut: ['galvanick:admin', 'galvanick:user'],
  assetsAssetIdIpAddressesGet: [],
  assetsAssetIdMacAddressesGet: [],
  assetsAssetIdProcessesGet: [],
  assetsAssetIdProcessesProcessGet: [],
  assetsAssetIdStatePatch: ['galvanick:admin'],
  assetsCommunicationsDaysByAssetGet: [],
  assetsCommunicationsGapsGet: [],
  assetsCommunicationsGet: [],
  assetsCommunicationsHourlyByAssetGet: [],
  assetsCommunicationsHourlyByIpGet: [],
  assetsCommunicationsHourlyByTupleGet: [],
  assetsConnectionsGet: [],
  assetsDistinctValuesGet: [],
  assetsFindingsGet: [],
  assetsGet: [],
  assetsIdGet: [],
  assetsIdPatch: ['galvanick:admin', 'galvanick:user'],
  assetsIdsGet: [],
  assetsNetworkActivityPost: [],
  assetsProcessesGet: [],
  assetsProcessTreeGet: [],
  assetsQuerySetsDelete: ['galvanick:admin', 'galvanick:user'],
  assetsQuerySetsGet: [],
  assetsQuerySetsPost: ['galvanick:admin', 'galvanick:user'],
  assetsQuerySetsPut: ['galvanick:admin', 'galvanick:user'],
  assetsServicesGet: [],
  assetsServicesGroupedGet: [],
  assetsTagsDelete: ['galvanick:admin', 'galvanick:user'],
  assetsTagsGet: [],
  assetsTagsPost: ['galvanick:admin', 'galvanick:user'],
  assetsTagsPut: ['galvanick:admin', 'galvanick:user'],
  assetsTagsTypesDelete: ['galvanick:admin', 'galvanick:user'],
  assetsTagsTypesGet: [],
  assetsTagsTypesPost: ['galvanick:admin', 'galvanick:user'],
  assetsTagsTypesPut: ['galvanick:admin', 'galvanick:user'],
  assetsToTagsPost: ['galvanick:admin', 'galvanick:user'],
  assetsToTagsPut: ['galvanick:admin', 'galvanick:user'],
  buildingsGet: [],
  buildingsIdGet: [],
  buildingsPost: ['galvanick:admin'],
  buildingsPut: ['galvanick:admin'],
  closureCategoriesGet: [],
  closureCategoriesIdGet: [],
  closureCodesGet: [],
  closureCodesIdGet: [],
  contactPost: ['galvanick:admin', 'galvanick:user'],
  customAssetAttributesDelete: ['galvanick:admin'],
  customAssetAttributesGet: [],
  customAssetAttributesPost: ['galvanick:admin'],
  customAssetAttributesPut: ['galvanick:admin'],
  endpointLogSourcesGet: [],
  endpointLogSourcesPut: ['galvanick:admin'],
  endpointSensorsGet: [],
  endpointSensorsIdGet: [],
  endpointSensorsPut: ['galvanick:admin'],
  findingHistoryGet: [],
  findingsGet: [],
  findingsIdGet: [],
  galvanickAppliancesGet: [],
  galvanickAppliancesIdGet: [],
  galvanickAppliancesLocalPrefixesDelete: ['galvanick:admin'],
  galvanickAppliancesLocalPrefixesPost: ['galvanick:admin'],
  galvanickAppliancesPost: ['galvanick:admin'],
  galvanickAppliancesPut: ['galvanick:admin'],
  geminiGet: [],
  geminiPost: ['galvanick:admin'],
  huntReportsFileNameGet: [],
  huntReportsGet: [],
  idsEventsGet: [],
  idsEventsGroupedCategoriesGet: [],
  idsEventsGroupedRulesGet: [],
  idsEventsIdGet: [],
  ipEnrichmentGet: [],
  ipEnrichmentHistoryGet: [],
  networkLogSourcesGet: [],
  networkLogSourcesPut: ['galvanick:admin'],
  networkPrefixesGet: [],
  networkPrefixesIdGet: [],
  networkPrefixesPost: ['galvanick:admin'],
  networkPrefixesPut: ['galvanick:admin'],
  networkPrefixesToTagsDelete: ['galvanick:admin'],
  networkPrefixesToTagsGet: ['galvanick:admin'],
  networkPrefixesToTagsPost: ['galvanick:admin'],
  pcapUploadsPresignPost: ['galvanick:admin'],
  pcapUploadsProcessPost: ['galvanick:admin'],
  reportsFindingsGet: [],
  reportsFindingsPost: ['galvanick:admin', 'galvanick:user'],
  reportsGet: [],
  rollupsAffectedAssetsByDayGet: [],
  rollupsAssetsByDayGet: [],
  rollupsDashboardGet: [],
  rollupsDataTransferByDayGet: [],
  sensorsGet: [],
  sensorThresholdsGet: [],
  sensorThresholdsPut: ['galvanick:admin'],
  suppressionsGet: [],
  suppressionsUpsert: ['galvanick:admin'],
  ticketsCommentGet: [],
  ticketsCommentPost: ['galvanick:admin', 'galvanick:user'],
  ticketsHistoryPost: ['galvanick:admin', 'galvanick:user'],
  ticketStatusChangesGet: [],
  usersEnabledPut: ['galvanick:admin'],
  usersEventsGet: ['galvanick:admin'],
  usersEventTypesGet: [],
  usersGet: [],
  usersGroupDelete: ['galvanick:admin'],
  usersGroupPut: ['galvanick:admin'],
  usersGroupsGet: ['galvanick:admin'],
  usersIdCredentialsGet: [],
  usersIdEventsGet: [],
  usersIdGet: [],
  usersIdMfaDelete: ['galvanick:admin'],
  usersIdPatch: ['galvanick:admin', 'galvanick:user'],
  usersOrganizationsGet: ['galvanick:admin'],
  usersOrganizationsIdGet: ['galvanick:admin'],
  usersPasswordPost: ['galvanick:admin'],
  usersPost: ['galvanick:admin'],
  valuesGet: [],
  vlansGet: [],
  vlansIdGet: [],
  vlansPost: ['galvanick:admin'],
  vlansPut: ['galvanick:admin'],
  vrfsGet: [],
  vrfsIdGet: [],
  vrfsPost: ['galvanick:admin'],
  vrfsPut: ['galvanick:admin'],
  vrfsToTagsDelete: ['galvanick:admin'],
  vrfsToTagsGet: ['galvanick:admin'],
  vrfsToTagsPost: ['galvanick:admin'],
} as const satisfies Record<string, ReadonlyArray<RequiredRole>>

export type Operation = keyof typeof OPERATION_ROLES
